/**
 * clientPodcasts.js - Audio and Co client show catalogue.
 *
 * FEATURED = the flagship spotlight (Katie Bell / Treat Your Business,
 * on the full Pro Plan / Podcast Visibility Package).
 *
 * SUPPORTED = every other show we produce or have supported. Cover art
 * URLs are pulled from Apple Podcasts CDN; the frontend hits
 * /api/podcasts/parse-rss on mount to enrich with latest episode + count.
 */

export const FEATURED = {
  slug: 'treat-your-business',
  title: 'Treat Your Business',
  host: 'Katie Bell',
  hostSub: 'Founder, Thrive Business Coaching',
  description:
    "Business growth for clinic owners and health professionals. Katie is our flagship Pro Plan client — we produce every episode, every YouTube long-form, the daily Shorts, show notes, blog and community posts weekly.",
  justShipped: 'Just shipped: a 52-week podcast strategy running Oct 2026 → Sept 2027',
  rssFeed: 'https://feeds.buzzsprout.com/2090945.rss',
  appleUrl: 'https://podcasts.apple.com/podcast/treat-your-business/id1616187313',
  spotifyUrl: 'https://open.spotify.com/show/2R7ojLbBxpi2eCPfxGWlbT',
  websiteUrl: 'https://thrive-businesscoaching.com',
  coverArt:
    'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/94/15/87/941587b0-5574-1a38-c078-1378079809fe/mza_11066063311020046754.jpg/600x600bb.jpg',
  wins: [
    { label: 'Episodes shipped', value: '200+' },
    { label: 'Clinic owners reached', value: '500+' },
    { label: 'Weekly outputs', value: '31' },
    { label: 'On Pro Plan', value: 'Since 2023' },
  ],
  quote: "Audio & Co. handles everything. I just turn up, talk about what I know, and they make it sound incredible.",
};

// Order roughly matches launch date; oldest first so alumni feel weighted at the top.
export const SUPPORTED = [
  {
    slug: 'the-scrumptious-woman',
    title: 'The Scrumptious Woman',
    host: 'Juliette Karaman',
    description:
      'Empowering women to embrace their sensuality, pleasure and authentic power. Launched with Audio and Co and hit the top 10% worldwide in month two.',
    rssFeed: 'https://feeds.buzzsprout.com/2208024.rss',
    appleUrl: 'https://podcasts.apple.com/podcast/id1698620594',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/6c/39/aa/6c39aadd-0f72-7c86-389f-11c95f9a2ff3/mza_7761729413429723081.jpg/600x600bb.jpg',
    tag: 'Launched & managed',
    ranking: 'Global top 5%',
  },
  {
    slug: 'the-cut-flower-podcast',
    title: 'The Cut Flower Podcast',
    host: 'Roz Chandler',
    description:
      'For anyone who grows or wants to grow cut flowers. Roz is a cut flower farmer with nearly ten years of experience, championing the Slow Flowers Movement.',
    rssFeed: 'https://feeds.buzzsprout.com/1491655.rss',
    appleUrl: 'https://podcasts.apple.com/podcast/id1520763648',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/7e/54/a7/7e54a797-35a4-5718-da99-b4ac2ccb0d48/mza_3578902708311632652.jpg/600x600bb.jpg',
    tag: 'Long-running',
    ranking: 'Global top 1.5%',
  },
  {
    slug: 'beyond-the-words',
    title: 'Beyond the Words',
    host: 'Dimple Thakrar',
    description:
      'Former NHS clinical dietitian Dimple explores intuition, healing and the deeper connections beyond language. Practical wisdom for trusting your inner voice.',
    rssFeed: 'https://feeds.buzzsprout.com/2246693.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/e8/fb/56/e8fb56d7-f5c0-5b07-9677-5340111080f0/mza_9382845821145882332.jpg/600x600bb.jpg',
    tag: 'Launched & managed',
    ranking: 'Global top 5%',
  },
  {
    slug: 'ask-dr-jodi',
    title: 'Ask Dr. Jodi',
    host: 'Dr. Jodi Aman',
    description:
      'Mental health and relationship guidance from a trauma-informed therapist with 28 years of clinical experience. Practical advice for anxiety and emotional wellness.',
    rssFeed: 'https://feeds.simplecast.com/ie6KAqyJ',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/e9/f4/06/e9f406c7-ec72-befc-c83e-cf777a68fe5f/mza_8505560877737041918.jpg/600x600bb.jpg',
    tag: 'Health',
  },
  {
    slug: 'future-proof-your-business',
    title: 'Future Proof Your Business',
    host: 'Lucy Rennie',
    description:
      'Helping small business owners build sustainable businesses that work for them. Clarity, communication and connection to future-proof what you have built.',
    rssFeed: 'https://feeds.buzzsprout.com/2276976.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/be/72/c7/be72c775-afb2-1a79-f525-0b23168a3950/mza_11592062604956210356.jpg/600x600bb.jpg',
    tag: 'Business',
  },
  {
    slug: 'beyond-the-clinic',
    title: 'Beyond the Clinic',
    host: 'Sarah Almond Bushell',
    hostSub: 'Certified Business Strategist',
    description:
      'For registered health professionals building scalable businesses beyond the traditional clinic. Sarah is our launched-and-managed client for both podcast and YouTube channel.',
    rssFeed: 'https://feeds.buzzsprout.com/2320439.rss',
    appleUrl: 'https://podcasts.apple.com/podcast/beyond-the-clinic/id1747019321',
    youtubeUrl: 'https://www.youtube.com/@BeyondTheClinicPodcast',
    websiteUrl: 'https://www.sarahalmondbushell.com/',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/27/ed/5f/27ed5f13-3f61-5ab2-4b6a-6be022510493/mza_956745936563781518.jpg/600x600bb.jpg',
    tag: 'Launched & managed',
    ranking: 'Podcast + YouTube launch',
  },
  {
    slug: 'the-calling',
    title: 'The Calling',
    subtitle: 'Follow Your Spirit All The Way In',
    host: 'Homaya',
    description:
      'Spiritual guidance and personal transformation. A journey into consciousness, purpose and authentic living for those ready to answer their calling.',
    rssFeed: 'https://feeds.buzzsprout.com/2253958.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/e6/57/fa/e657fab0-bcff-15e4-6d2c-de9cd2f5bfb2/mza_7770022858614241784.jpg/600x600bb.jpg',
    tag: 'Launched & managed',
    ranking: 'Global top 10%',
  },
  {
    slug: 'the-miracle-zone',
    title: 'The Miracle Zone',
    host: 'Client show',
    description:
      'Exploring miracles, manifestation and conscious creation. Inspiring stories and practical wisdom for extraordinary results in everyday life.',
    rssFeed: 'https://feeds.buzzsprout.com/2451031.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/7b/66/d5/7b66d50a-fe6b-ea6a-5f2d-93e4ba8951a7/mza_11113047695026928611.jpg/600x600bb.jpg',
    tag: 'Spiritual',
  },
  {
    slug: 'the-human-archive',
    title: 'The Human Archive',
    host: 'Client show',
    description:
      'Preserving and sharing human stories, wisdom and experiences. Deep conversations exploring what it means to be human in the modern world.',
    rssFeed: 'https://feeds.buzzsprout.com/2461637.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/1b/59/c5/1b59c587-e377-bc20-fefb-648ecc64a89c/mza_16987769956847649197.jpg/600x600bb.jpg',
    tag: 'Culture',
  },
  {
    slug: 'the-human-design-channel',
    title: 'The Human Design Channel',
    host: 'Client show',
    description:
      'Exploring the Human Design system and how to live in alignment with your unique energetic blueprint. Practical insights for decisions and authenticity.',
    rssFeed: 'https://feeds.buzzsprout.com/2464994.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/96/b9/2d/96b92d41-ef9e-51b3-36a2-e8a3b16ca8e2/mza_10609962401352210145.jpg/600x600bb.jpg',
    tag: 'Spiritual',
  },
  {
    slug: 'designed-to-be-awake',
    title: 'Designed to be Awake',
    host: 'Mick Kubiak',
    description:
      'Consciousness expansion and spiritual awakening in the modern world. Practical guidance for living awakened while navigating everyday challenges.',
    rssFeed: 'https://feed.podbean.com/mickkubiakbiz/feed.xml',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts221/v4/c2/0d/76/c20d76ae-1bab-e2a7-a2bd-323a4c518e3d/mza_17136351918011301653.jpg/600x600bb.jpg',
    tag: 'Spiritual',
  },
  {
    slug: 'my-mighty-quinn',
    title: 'My Mighty Quinn',
    host: 'Client show',
    description:
      'Celebrating resilience and the power of the human spirit. Inspiring stories of overcoming challenges and creating extraordinary outcomes from ordinary moments.',
    rssFeed: 'https://feeds.buzzsprout.com/2227644.rss',
    coverArt:
      'https://is1-ssl.mzstatic.com/image/thumb/Podcasts211/v4/38/d3/71/38d37109-1373-d128-3dea-7ca09cb897a4/mza_8368873268412536214.jpg/600x600bb.jpg',
    tag: 'Culture',
  },
];

export default { FEATURED, SUPPORTED };
